(() => {
	let thirdPartyScriptAdded = false;
	const thirdPartysSriptPaths = [
		"https://www.tiktok.com/embed.js"
	];

	const addThirdPartyScripts = () => {
		// check if script was added, to prevent multiple script adding
		if (!thirdPartyScriptAdded) {
            thirdPartysSriptPaths.forEach((thirdPartyScriptPath) => {
                const thirdPartyScript = document.createElement("script");
                thirdPartyScript.src = thirdPartyScriptPath;
                document.head.appendChild(thirdPartyScript);
            });
    
			thirdPartyScriptAdded = true;
		}
	};

	window.addEventListener("click", addThirdPartyScripts);
	window.addEventListener("mousemove", addThirdPartyScripts);
	window.addEventListener("scroll", addThirdPartyScripts);
	window.addEventListener("touchstart", addThirdPartyScripts);
})();
